import React from "react";
import Iframe from "react-iframe";
import {LoadingCenter} from "@bounce/shared/ui";
import {useGetEmbeddedDashboardURL} from "../../apis/requests/dashboards/getEmbeddedDashboardURL";

const DASHBOARD_NAME = "reach_digital_funnel_reports_per_template";

const DashboardPage = () => {
  const {data: dashboardURL} = useGetEmbeddedDashboardURL({dashboardName: DASHBOARD_NAME});

  if (!dashboardURL) {
    return <LoadingCenter />;
  }

  return <Iframe url={dashboardURL} width="100%" height="100%" styles={{border: "none"}} />;
};

export default DashboardPage;
